import { ICoralCategory } from "../../model/Category";

export const coralsV2: ICoralCategory[] = [
    {
        id: 1,
        name: "LPS",
        imageUrl: "/images/category-images/LPS.jpeg",
        subCategories: [
            {
                id: 1,
                name: "Favia",
                imageUrl: "/images/corals/img.png",
                products: [
                    {
                        name: "Green blackhole favia colony",
                        description: "Colonie de favia approximativement la taille d'une paume de main adulte moyenne. Favia colony approximatively the size of an average adult size hand palm.",
                        price: 60,
                        imageUrl: ["/images/corals/img.png"],
                        variants: [],
                        isAvailable: true
                    }
                ]
            },
            {
                id: 2,
                name: "Euphyllia",
                imageUrl: "/images/corals/Pink tip green torch.png",
                products: [
                    {
                        name: "Green pink tip torch",
                        description: "Prix par tete / price per head",
                        price: 60,
                        imageUrl: ["/images/corals/Pink tip green torch.png"],
                        variants: [],
                        isAvailable: true
                    },
                    {
                        name: "Golden aussie branching hammer small colony (3 heads)",
                        description: "Magnifique 3 tetes hammer australien dorée avec un peu de bleu. Beautiful 3 headed aussie golden hammer small colony with a bit of blue tones.",
                        price: 75,
                        imageUrl: ["/images/corals/golden_aussie_branching_hammer_533x800.png"],
                        variants: [
                            {
                                id: 1,
                                name: "Golden aussie branching hammer colony (5 heads)",
                                price: 100,
                                isAvailable: false
                            }
                        ],
                        isAvailable: true
                    },
                    {
                        name: "Hulk frogspawn",
                        description: "Prix par tete/ price per head",
                        price: 40,
                        imageUrl: ["/images/corals/Hulk frogspawn  2.jpg", "/images/corals/Hulk frogspawn.png"],
                        variants: [],
                        isAvailable: true
                    },
                    {
                        name: "Golden hammer",
                        description: "Prix par tete/price per head",
                        price: 20,
                        imageUrl: ["/images/corals/Golden branching hammer.png"],
                        variants: [
                            {
                                id: 1,
                                name: "Golden hammer (2 head frag)",
                                price: 30,
                                isAvailable:true
                            }
                        ],
                        isAvailable: true
                    }
                ]
            },
            {
                id: 3,
                name: "Goniopora",
                imageUrl: "/images/corals/Yellow center goniopora.jpg",
                products: [
                    {
                        name: "Red yellow center goniopora frag (large)",
                        description: "Gros frag goniopora rouge avec centre jaune. Generous red goniopora with yellow center frag. Les mini colony sont environ 2-3x fois plus gros que un frag. Mini-colonies are around 2-3x times the size of a frag.",
                        price: 35,
                        imageUrl: ["/images/corals/Yellow center goniopora.jpg"],
                        variants: [
                            {
                                id: 1,
                                name: "Red yellow center goniopora mini-colony",
                                price: 50,
                                isAvailable: true
                            }
                        ],
                        isAvailable: false
                    }
                ]
            },
            {
                id: 4,
                name: "Duncan",
                imageUrl: "/images/corals/Blue duncan colony 2.png",
                products: [
                    {
                        name: "Blue Australian Duncan colony (5 heads)",
                        description: "Colonie de Duncan australien (5 tetes) variation mauve et bleu. 15$/tete wow. 5 head colony of a blue purple variant of the australian Duncan. 15$/head only wow!",
                        price: 75,
                        imageUrl: ["/images/corals/Blue duncan colony 2.png"],
                        variants: [],
                        isAvailable: true
                    }
                ]
            }
        ]
    },
    {
        id: 2,
        name: "Soft",
        imageUrl: "/images/category-images/soft.jpg",
        subCategories: [
            {
                id: 21,
                name: "Mushroom",
                imageUrl: "/images/corals/Bullseye rhodactis mushroom 2.png",
                products: [
                    {
                        name: "Orange ricordea mushroom",
                        description: "Prix par mushroom/price per mushroom",
                        price: 15,
                        imageUrl: ["/images/corals/Florida Ricordea mushroom.png"],
                        variants: [
                            {
                                id: 1,
                                name: "Mini ricodea florida orange mushroom (small)",
                                price: 10,
                                isAvailable:false
                            }
                        ],
                        isAvailable: true
                    },
                    {
                        name: "Bullseye rhodactis mushroom",
                        description: "Prix par mushroom/price per mushroom wyisyg",
                        price: 25,
                        imageUrl: ["/images/corals/Bullseye rhodactis mushroom 2.png"],
                        variants: [],
                        isAvailable: true
                    }
                ]
            },
            {
                id: 22,
                name: "Zoanthid & Palythoa",
                imageUrl: "/images/category-images/soft.jpg",
                products: [
                    {
                        name: "Captain jerk palythoa mini colony",
                        description: "5-8 tetes sur un plug. 5-8 heads on a plug",
                        price: 10,
                        imageUrl: ["/images/corals/Captain jerk zoa.png"],
                        variants: [
                            {
                                id: 1,
                                name: "Captain jerk palythoa colony (25 heads +)",
                                price: 20,
                                isAvailable: true
                            }
                        ],
                        isAvailable: true
                    }
                ]
            }
        ]
    }
];